import { doc, onSnapshot } from 'firebase/firestore';
import { firestore } from '~/firebase/init';

import { SnapshotFn } from '~/firebase/listeners/type';

export function itemListener(storeId: string, itemId: string, onNext: SnapshotFn) {
  const ref = doc(firestore, 'stores', storeId, 'items', itemId);

  return onSnapshot(ref, {
    next: onNext,
    error: () => {
      console.error(`listen stores/${storeId}/items/${itemId} error`);
    },
  });
}
